import React, { useContext, useState } from 'react';
import { MiFooter } from "../../components/footer/MiFooter";
import Header from "../../components/headers/Header";
import { ContentPresupuestos } from '../../components/Presupuestos/ContentPresupuestos';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { ModalEnviarPresupuesto } from '../../components/Presupuestos/ModalEnviarPresupuesto';
import './Presupuestos.css';

export const Presupuestos = () => {


  const [MenuLateralAux, setMenuLateralAux] = useState(false);


  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }
  return (
    <>

    <div className="Presupuestos" >
        <div className="headerPresupuestos">
          <Header
            chageMenuLateralAux={chageMenuLateralAux}
          />
        </div>
        <div className="bodyPresupuestos">
            <ContentPresupuestos
            MenuLateralAux={MenuLateralAux}
            chageMenuLateralAux={chageMenuLateralAux}
            />
        </div>
        <div className="footerPresupuestos">
            <MiFooter/>
        </div>
    </div>
    </>
  )
}
